import React from 'react';
import { createRoot } from 'react-dom/client';
import Bugsnag from '@bugsnag/js';
import { Provider } from 'react-redux';
import { notification } from 'antd';
import store from './javascripts/store/ReduxStore';
import 'react-virtualized/styles.css';
import 'react-base-table/styles.css';
import './stylesheets/_index.scss';
import '@pdm/ui-components/dist/ui-components.css';
import '@pdm/axel-ui-components/dist/axel-ui-components.css';
import './i18n';
import { createBugsnagClient } from './javascripts/actions/tools/BugsnagActions';
import AppRoutes from './javascripts/routes/Routes';
import { AuthProvider } from './javascripts/contexts/AuthContext';

store.dispatch(createBugsnagClient() as any);
const BugsnagErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary();

notification.config({
  placement: 'bottomRight',
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <BugsnagErrorBoundary>
    <Provider store={store}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Provider>
  </BugsnagErrorBoundary>
);

if ((window as any).Cypress) {
  (window as any).store = store;
}
